"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortalAssetImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing PortalAsset operations. */
var PortalAssetImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class PortalAsset class.
   * @param client Reference to the service client
   */
  function PortalAssetImpl(client) {
    (0, _classCallCheck2["default"])(this, PortalAssetImpl);
    this.client = client;
  }
  /**
   * @param portalId
   * @param assetPath
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(PortalAssetImpl, [{
    key: "getAngularTemplate",
    value: function getAngularTemplate(portalId, assetPath, options) {
      var operationArguments = {
        portalId: portalId,
        assetPath: assetPath,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAngularTemplateOperationSpec);
    }
    /**
     * @param portalId
     * @param assetPath
     * @param options The options parameters.
     */

  }, {
    key: "getTemplate",
    value: function getTemplate(portalId, assetPath, options) {
      var operationArguments = {
        portalId: portalId,
        assetPath: assetPath,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getTemplateOperationSpec);
    }
    /**
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getStyles",
    value: function getStyles(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getStylesOperationSpec);
    }
    /**
     * @param portalId
     * @param fontName
     * @param options The options parameters.
     */

  }, {
    key: "getFontAsset",
    value: function getFontAsset(portalId, fontName, options) {
      var operationArguments = {
        portalId: portalId,
        fontName: fontName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getFontAssetOperationSpec);
    }
    /**
     * @param portalId
     * @param imageName
     * @param options The options parameters.
     */

  }, {
    key: "getImageAsset",
    value: function getImageAsset(portalId, imageName, options) {
      var operationArguments = {
        portalId: portalId,
        imageName: imageName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getImageAssetOperationSpec);
    }
    /** @param options The options parameters. */

  }, {
    key: "getFavicon",
    value: function getFavicon(options) {
      var operationArguments = {
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getFaviconOperationSpec);
    }
  }]);
  return PortalAssetImpl;
}(); // Operation Specifications


exports.PortalAssetImpl = PortalAssetImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getAngularTemplateOperationSpec = {
  path: "/api/Portals({portalId})/templates/AngularTemplates/{assetPath}",
  httpMethod: "GET",
  responses: {
    200: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetPath],
  serializer: serializer
};
var getTemplateOperationSpec = {
  path: "/api/Portals({portalId})/templates/{assetPath}",
  httpMethod: "GET",
  responses: {
    200: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetPath],
  serializer: serializer
};
var getStylesOperationSpec = {
  path: "/api/Portals({portalId})/Css",
  httpMethod: "GET",
  responses: {
    200: {}
  },
  queryParameters: [Parameters.version],
  urlParameters: [Parameters.$host, Parameters.portalId],
  serializer: serializer
};
var getFontAssetOperationSpec = {
  path: "/api/Portals({portalId})/Fonts/{fontName}",
  httpMethod: "GET",
  responses: {
    200: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.fontName],
  serializer: serializer
};
var getImageAssetOperationSpec = {
  path: "/api/Portals({portalId})/Images/{imageName}",
  httpMethod: "GET",
  responses: {
    200: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.imageName],
  serializer: serializer
};
var getFaviconOperationSpec = {
  path: "/favicon.ico",
  httpMethod: "GET",
  responses: {
    200: {}
  },
  urlParameters: [Parameters.$host],
  serializer: serializer
};